module.exports = __webpack_public_path__ + "img/romano-perumal.699d9c49.png";